import { Task } from 'twilio-taskrouter';
import isEmpty from 'lodash/isEmpty';
import CbmParticipant, { ParticipantEventData } from '../CbmParticipant';
import TwilioError from '../util/TwilioError';
import { getRoute, INTERACTION_MODIFY_PARTICIPANT } from '../util/Routes';
import { post } from '../util/Request';
import { getInteractionSid } from '../util/FlexInteractionSid';
import { getParticipantSidFromEvent } from '../util/ParticipantSid';
import { ParticipantResponse } from './types/AddParticipant';
import { promiseOrTimeout } from '../util/EventsTimeout';
import { TaskAttributes } from './types/TaskAttributes';









interface Options {
    closeChannelIfLastParticipant?: boolean;
}
export default async function removeParticipant(
    task: Task,
    sid: string,
    options: Options = {}
): Promise<CbmParticipant> {
    if ((isEmpty(task.attributes) as TaskAttributes)?.flexInteractionChannelSid) {
        throw new Error(
            `Failed to remove a participant from the Task sid=${task.sid}. Missing flexInteractionChannelSid.`
        );
    }

    let participant: ParticipantResponse | undefined;

    const eventReceived = new Promise((resolve: (value: CbmParticipant) => void, reject) => {
        
        const participantRemovedHandler = (_: any, event: ParticipantEventData) => {
            const eventParticipantSid = getParticipantSidFromEvent(event);
            if (eventParticipantSid === participant?.sid) {
                task.removeListener('participantRemoved', participantRemovedHandler);
                resolve(new CbmParticipant(event));
            }
        };
        task.on('participantRemoved', participantRemovedHandler);

        
        const participantRemoveFailedHandler = (_: any, event: any) => {
            const eventParticipantSid = getParticipantSidFromEvent(event);
            if (eventParticipantSid === participant?.sid) {
                task.removeListener('participantRemoveFailed', participantRemoveFailedHandler);
                reject(
                    new TwilioError(
                        event,
                        `Failed to remove Participant from Task sid=${task.sid}. Reason: ${event.reason}`
                    )
                );
            }
        };
        task.on('participantRemoveFailed', participantRemoveFailedHandler);
    });

    const channelSid = (task.attributes as TaskAttributes).flexInteractionChannelSid;
    const interactionSid = getInteractionSid(task);
    const requestURL = getRoute(INTERACTION_MODIFY_PARTICIPANT, interactionSid, channelSid!, sid).path;
    const requestParams = { status: 'closed', ...options };
    participant = await post<ParticipantResponse>(requestURL, requestParams);

    return promiseOrTimeout<CbmParticipant>(eventReceived, 'Task.participantRemoved');
}
